(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7698],{

/***/ 7698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LINK_TRACKING_DELAY": function() { return /* binding */ LINK_TRACKING_DELAY; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers_session__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43687);
/* harmony import */ var _helpers_env__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13627);
/* harmony import */ var _consts_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62872);
/* harmony import */ var _svgs_uk_flag_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93785);
/* harmony import */ var _svgs_eu_flag_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36384);
/* harmony import */ var _svgs_us_flag_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87800);
/* harmony import */ var _components_ui_Modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15203);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43340);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _helpers_analytics__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8288);











var LINK_TRACKING_DELAY = 300;
var COUNTRIES = [
    {
        image: _svgs_uk_flag_svg__WEBPACK_IMPORTED_MODULE_5__/* .ReactComponent */ .r,
        locale: "gb",
        text: "UK"
    },
    {
        image: _svgs_eu_flag_svg__WEBPACK_IMPORTED_MODULE_6__/* .ReactComponent */ .r,
        locale: "eu",
        text: "EU"
    },
    {
        image: _svgs_us_flag_svg__WEBPACK_IMPORTED_MODULE_7__/* .ReactComponent */ .r,
        locale: "us",
        text: "US"
    }
];
function CountryModal(param) {
    var shopLocale = param.shopLocale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isOpen = ref[0], setIsOpen = ref[1];
    var geoRegionCode = (0,_helpers_session__WEBPACK_IMPORTED_MODULE_2__/* .getCookieByName */ .A7)("geo_region_code");
    var handleCountrySelection = function(ev, countryLocale) {
        ev === null || ev === void 0 ? void 0 : ev.preventDefault();
        var currentTarget = (ev || {}).currentTarget;
        var thChosenCookieValue = countryLocale || shopLocale;
        (0,_helpers_analytics__WEBPACK_IMPORTED_MODULE_9__/* .analytics */ .co)("Geo Modal Prompt", {
            action: countryLocale ? "".concat(currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.title, " flag") : "close",
            th_chosen: thChosenCookieValue,
            geo_region_code: geoRegionCode
        });
        (0,_helpers_session__WEBPACK_IMPORTED_MODULE_2__/* .setCookie */ .d8)("th_chosen", thChosenCookieValue, _consts_index__WEBPACK_IMPORTED_MODULE_4__/* .COOKIE_EXPIRE_1_MONTH */ .Hp, true);
        if (currentTarget && countryLocale !== shopLocale) {
            setTimeout(function() {
                window.location.assign(currentTarget.href);
            }, LINK_TRACKING_DELAY);
        } else {
            setIsOpen(false);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_Modal__WEBPACK_IMPORTED_MODULE_8__["default"], {
        openedModal: isOpen,
        onClose: function() {
            return handleCountrySelection();
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().CountryModal),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: "Where are we shipping to?"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "Purchasing from your country's website is the best way to get the perfect fit"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().linksWrapper),
                    children: COUNTRIES.map(function(param) {
                        var Image = param.image, locale = param.locale, text = param.text;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().link),
                            href: (0,_helpers_env__WEBPACK_IMPORTED_MODULE_3__/* .replaceLocale */ .mC)((locale === null || locale === void 0 ? void 0 : locale.toUpperCase()) === "GB" ? "" : "/".concat(locale === null || locale === void 0 ? void 0 : locale.toLowerCase())),
                            onClick: function(ev) {
                                return handleCountrySelection(ev, locale.toUpperCase());
                            },
                            title: text,
                            hrefLang: locale,
                            rel: "alternate",
                            "aria-label": "Switch to our ".concat(text, " store"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
                                    width: "106",
                                    height: "80"
                                }),
                                text
                            ]
                        }, locale);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_10___default().footerMessage),
                    children: "Somewhere else? Head to the UK store, and select your country at checkout."
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (CountryModal);


/***/ }),

/***/ 43340:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CountryModal":"styles_CountryModal__Nmnnr","footerMessage":"styles_footerMessage__VjejX","linksWrapper":"styles_linksWrapper__eEPVY","link":"styles_link__q7uiH"};

/***/ })

}]);